"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEnrichGroupInfoAddress = void 0;
const utils_1 = require("../utils");
const useEnrichGroupInfoAddress = () => {
    const clearAddress = (groupInfo) => {
        if (groupInfo.patientInfo) {
            return Object.assign(Object.assign({}, groupInfo), { patientInfo: Object.assign(Object.assign({}, groupInfo.patientInfo), { address: {} }) });
        }
        return groupInfo;
    };
    const updateAddress = (groupInfo, address) => {
        var _a, _b;
        if (groupInfo.patientInfo && groupInfo.patientInfo.address) {
            const existingAddress = (_a = groupInfo.patientInfo) === null || _a === void 0 ? void 0 : _a.address;
            return Object.assign(Object.assign({}, groupInfo), { patientInfo: Object.assign(Object.assign({}, groupInfo.patientInfo), { address: Object.assign(Object.assign({}, groupInfo.patientInfo.address), { geoLocation: (_b = existingAddress === null || existingAddress === void 0 ? void 0 : existingAddress.geoLocation) !== null && _b !== void 0 ? _b : {
                            coordinates: [address.location.lng, address.location.lat],
                            type: "Point",
                        }, lat: address.location.lat, lng: address.location.lng, placeName: address.formattedAddress }) }) });
        }
        return groupInfo;
    };
    const enrichAddress = (groupInfo, googleMapsApiKey) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const placeName = (_b = (_a = groupInfo.patientInfo) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.placeName;
        if (!!placeName) {
            const searchResult = yield (0, utils_1.searchAddress)(placeName, googleMapsApiKey);
            if (searchResult.length > 0) {
                const parsedAddress = searchResult[0];
                return updateAddress(groupInfo, parsedAddress);
            }
            else {
                return clearAddress(groupInfo);
            }
        }
        return groupInfo;
    });
    return { enrichAddress };
};
exports.useEnrichGroupInfoAddress = useEnrichGroupInfoAddress;
